import _ from 'lodash';
import moment from 'moment';
import getErrors from '../../../../shared/lib/geterrors';
import CoordinatoreService from '../../../../shared/services/api/coordinatore';

export const onCoordinatoreSubmit = (
  values,
  { setSubmitting, setErrors, setValues },
  { anagraficaId, update, notifications }
) => {
  const payload = {
    ...values,
    anagrafica: anagraficaId,
    agenziekiron: values.agenziekiron.map((ak) => ({ id: ak.value })),
    dataInizio: values.dataInizio ? +moment(values.dataInizio).format('X') : null,
    dataFine: values.dataFine ? +moment(values.dataFine).format('X') : null,
  };

  if (!values.id || values.id.length === 0) {
    CoordinatoreService.create(payload)
      .then((data) => {
        setSubmitting(false);

        // Update form values if needed
        setValues({ ...values, id: data.id });

        // Success notification
        notifications.addNotification({
          message: 'Dati coordinatore salvati',
          level: 'success',
        });

        // Update parent list
        update();
      })
      .catch((errors) => {
        const errorsObj = getErrors(errors);
        setSubmitting(false);
        setErrors(errorsObj);

        // Error notification
        notifications.addNotification({
          message:
            _.get(errors, 'data.detail') ||
            'Si è verificato un problema con il salvataggio del coordinatore, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  } else {
    CoordinatoreService.put(payload)
      .then(() => {
        setSubmitting(false);
        notifications.addNotification({
          message: 'Dati coordinatore aggiornati',
          level: 'success',
        });
      })
      .catch((errors) => {
        const errorsObj = getErrors(errors);
        setSubmitting(false);
        setErrors(errorsObj);

        // Error notification
        notifications.addNotification({
          message:
            _.get(errors, 'data.detail') ||
            'Si è verificato un problema con il salvataggio del coordinatore, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  }
};

export default onCoordinatoreSubmit;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Coordinatore/submit.js